import { useEffect } from "react"
import { Box, Flex } from "@chakra-ui/react"
import { motion, useAnimation } from "framer-motion"

const generateRandomId = () => Math.random().toString(36).substr(2, 9)

type CarouselItems = {
  content: JSX.Element
}

type AnimatedCarouselProps = {
  items: CarouselItems[]
}

const MotionDiv = motion(Flex)

export default function AnimatedCarousel({ items }: AnimatedCarouselProps) {
  const controls = useAnimation()

  useEffect(() => {
    controls.start({
      x: ["0%", "-14.75%"],
      transition: {
        duration: 80,
        ease: "linear",
        repeat: Infinity,
        repeatType: "loop",
      },
    })
  }, [controls])

  return (
    <Box overflow="hidden" whiteSpace="nowrap">
      <MotionDiv display="inline-flex" alignItems="center" animate={controls}>
        {Array.from({ length: 7 }).map(() =>
          items.map((item) => (
            <Box
              key={`${generateRandomId()}`}
              minW="90px"
              minH="80px"
              mx={{ base: 0, md: 10 }}
              p={{ base: 2, md: 2 }}
              display="flex"
              justifyContent="center"
              alignItems="center"
              opacity="0.5"
              blendMode="multiply"
            >
              {item.content}
            </Box>
          )),
        )}
      </MotionDiv>
    </Box>
  )
}
